import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicePage from "../pages/services/page";
import BookingPage from "../pages/booking/page";
import ContactPage from "../pages/contact/page";
import AccountPage from "../pages/account/page";
import WasteCalculatorPage from "../pages/calculator/page";
import LocationsIndexPage from "../pages/locations/index";
import LocationPage from "../pages/locations/page";
import AboutPage from "../pages/about/page";
import NewsPage from "../pages/news/page";
import NewsPostPage from "../pages/news/components/NewsPostPage";
import CheckoutPage, { CheckoutSuccessPage } from "../pages/checkout/page";

// ... existing code ...

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/book",
    element: <BookingPage />,
  },
  {
    path: "/waste-calculator",
    element: <WasteCalculatorPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/account",
    element: <AccountPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/news",
    element: <NewsPage />,
  },
  {
    path: "/news/:slug",
    element: <NewsPostPage />,
  },
  {
    path: "/locations",
    element: <LocationsIndexPage />,
  },
  {
    path: "/locations/:slug",
    element: <LocationPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/checkout/success",
    element: <CheckoutSuccessPage />,
  },
  {
    path: "/:slug",
    element: <ServicePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
